/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Live_Caption_Latency_OffsetInputs */

const en_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Latency offset: ${i?.value}s`)
};

const fr_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Décalage de latence : ${i?.value}s`)
};

const de_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Latenzversatz: ${i?.value}s`)
};

const it_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offset di latenza: ${i?.value}s`)
};

const ru_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Смещение задержки: ${i?.value}s`)
};

const es_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desfase de latencia: ${i?.value}s`)
};

const zh_cn2_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`延迟偏移：${i?.value}s`)
};

const ja_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`遅延オフセット: ${i?.value}s`)
};

const hi_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`विलंबता ऑफ़सेट: ${i?.value}s`)
};

const pt_pt2_live_caption_latency_offset = /** @type {(inputs: Live_Caption_Latency_OffsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deslocamento de latência: ${i?.value}s`)
};

/**
* | output |
* | --- |
* | "Latency offset: {value}s" |
*
* @param {Live_Caption_Latency_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_latency_offset = /** @type {((inputs: Live_Caption_Latency_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Latency_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_latency_offset(inputs)
	if (locale === "de") return de_live_caption_latency_offset(inputs)
	if (locale === "it") return it_live_caption_latency_offset(inputs)
	if (locale === "ru") return ru_live_caption_latency_offset(inputs)
	if (locale === "es") return es_live_caption_latency_offset(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_latency_offset(inputs)
	if (locale === "ja") return ja_live_caption_latency_offset(inputs)
	if (locale === "hi") return hi_live_caption_latency_offset(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_latency_offset(inputs)
	return en_live_caption_latency_offset(inputs)
});